import React, { useState, useContext, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import { orderBy } from "lodash-es"
import UserSelectionItem from "./UserSelectionItem"
import { StatusInfoComponent } from "../../Shared"
import { store } from "../../app/store"
import { setProfiles } from "../../app/slices/profilesSlice"
import { setProfileId } from "../../app/slices/selectedProfileSlice"
import { useLoading, useProfiles } from "../../app/hooks"
import { StatusInfo, Card, Separator } from "@george-labs.com/design-system"
import AuthContext from "../../providers/AuthProvider"
import { setNotifications } from "../../app/slices/notificationSlice"
import { setCases } from "../../app/slices/casesSlice"
import { OAuth2ClientData } from "@smartx/mikro-vt-client-api"
import { userProfileApi } from "../../api/apiClient"
import { setStatusFilter } from "../../app/slices/dashboardFiltersSlice"

const UserSelection = () => {
  const authContext = useContext(AuthContext)
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [error, setError] = useState(false)

  const profiles = useProfiles()
  const loading = useLoading()

  useEffect(() => {
    store.dispatch(setProfileId(null))
    store.dispatch(setNotifications([]))
    store.dispatch(setCases([]))
    store.dispatch(setStatusFilter(null))

    if (profiles?.length === 1) {
      const userId = profiles.find((el) => !!el)?.id

      if (userId) {
        store.dispatch(setProfileId(userId))
        navigate("/dashboard")
      }
    }

    if (!profiles?.length) {
      authContext.refresh()
      userProfileApi
        .getUserProfile()
        .then((res) => {
          res.data.clients = orderBy(
            res.data.clients,
            ["mikroCompany", "name"],
            ["desc", "asc"],
          )
          store.dispatch(setProfiles(res.data.clients))
          if (
            res.data.clients.length === 1 &&
            res.data.clients[0].mikroCompany
          ) {
            store.dispatch(setProfileId(res.data.clients[0].id))
            navigate("/dashboard")
          }
        })
        .catch(() => {
          setError(true)
        })
    }
  }, [navigate, profiles, authContext])

  if (error) {
    return (
      <StatusInfoComponent
        variant={StatusInfo.VARIANT.ERROR}
      ></StatusInfoComponent>
    )
  }

  return (
    <>
      {!loading && profiles?.length === 0 && (
        <StatusInfoComponent
          variant={StatusInfo.VARIANT.DEFAULT}
        ></StatusInfoComponent>
      )}

      {!loading && profiles?.length > 0 && (
        <div>
          <h3 className="mb-3">{t("user-selection.title")}</h3>
          <Card nested={false} style={{ marginBottom: "3.5rem" }}>
            {profiles?.map((user: OAuth2ClientData) => {
              return (
                <React.Fragment key={`fr-${user.id}`}>
                  <UserSelectionItem key={user.id} userData={user} />
                  <Separator />
                </React.Fragment>
              )
            })}
          </Card>
        </div>
      )}
    </>
  )
}

export default UserSelection
